module.exports = __webpack_public_path__ + "static/15.4_romes_decline_and_legacy-b8b0e79ce46a8f216b6fbbd31d39dac5.pdf";